<template>
  <div class="home">
    <Header />
    <BannerPage
      bannerTitle="合作夥伴招募"
      bannerDesc="填寫您的基本聯繫資料，我們將與您聯絡，提供您更完整的新創企業資料，也替你安排與新創企業的第一次線上商談會議！"
      :bannerLogo="require(`@/assets/images/icon_cooperation.png`)"
    />
    <CooperatorForm />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import BannerPage from '@/components/reuse-component/BannerPage.vue';
import CooperatorForm from '@/components/introduction/CooperatorForm.vue';

export default {
  name: 'Cooperator',
  components: {
    Header,
    BannerPage,
    CooperatorForm,
  },
};
</script>
